import { Redirect, Route } from 'react-router-dom';
import { Subscribe } from 'unstated';

import UserContainer from '~/containers/User';

const GatedRoute = ({
  component: Component,
  render: renderProp,
  gateFunction,
  fallbackPath,
  ...props
}) => (
  <Subscribe to={[UserContainer]}>
    {(container) => {
      if (!container.currentUserLoaded() || !container.currentAccountLoaded()) {
        return null;
      }
      let renderComponent = () => <Redirect to={fallbackPath} />;

      if (Component) {
        renderComponent = (props) =>
          gateFunction(container) ? (
            <Component {...props} />
          ) : (
            <Redirect to={fallbackPath} />
          );
      }

      if (renderProp) {
        renderComponent = (props) =>
          gateFunction(container) ? (
            renderProp(props)
          ) : (
            <Redirect to={fallbackPath} />
          );
      }

      return <Route {...props} render={renderComponent} />;
    }}
  </Subscribe>
);

GatedRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.func,
  ]),
  render: PropTypes.func,
  gateFunction: PropTypes.func.isRequired,
  fallbackPath: PropTypes.string,
};

GatedRoute.defaultProps = {
  fallbackPath: '/',
};

export default GatedRoute;
